/* @flow */
import React from 'react';
// $FlowIgnore
import _ from 'lodash';

import { pluralize } from 'constants/plural';

import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';

type EmptyTableViewProps = {
  entity: string,
  IconComponent(props: Object): React.Element
}

function EmptyTableView({
  entity, IconComponent
}: EmptyTableViewProps): React.Element {
  return (
    <Row style={{
      justifyContent: 'center',
      alignItems: 'center',
      color: '#666',
      flex: 1
    }}>
      {IconComponent && IconComponent({style: {
        fontSize: '4rem',
        marginRight: '1rem'
      }})}
      <Column>
        <Row style={{
          fontSize: '2rem',
          margin: '.5rem 0',
          textTransform: 'capitalize'
        }}>{`No ${_.startCase(pluralize(entity))} Found.`}</Row>
        <Row>{`Submit data to see ${_.startCase(pluralize(entity))} here.`}</Row>
      </Column>
    </Row>
  );
}

export default EmptyTableView;
